import React from "react";
import * as RadixContextMenu from "@radix-ui/react-context-menu";
import styled from "styled-components";
import { Tooltip } from "./Tooltip";

interface ContextMenuItemProps {
  readonly iconName: string;
  readonly text: string;
  readonly onSelect: () => void;
  readonly disabled?: boolean;
  readonly tooltipContent?: React.JSX.Element | string;
}

const StyledContextMenuItem = styled(RadixContextMenu.Item)`
  display: flex;
  gap: ${({ theme }) => theme.spacing.spacing3.toString()};
  align-items: center;
  height: 40px;
  color: ${({ theme }) => theme.colors.contentEmphasis};
  font-weight: ${({ theme }) => theme.typography.weightNormal};
  border-radius: 6px;
  padding: 0 ${({ theme }) => theme.spacing.spacing2.toString()};
  transition-duration: 0.3s;
  transition: all 250ms;
  transition-property: background-color;
  transition-timing-function: cubic-bezier(0.2, 0.9, 0.4, 1);

  &:hover {
    background-color: ${({ theme }) => theme.colors.backgroundHover};
  }

  &:active {
    background-color: ${({ theme }) => theme.colors.backgroundPressed};
  }

  &[data-disabled] {
    color: ${({ theme }) => theme.colors.contentSubtle};
  }
`;

const TooltipContentContainer = styled.div`
  max-width: 255px;
`;

/**
 * @param {string} iconName - The tractie icon name
 */
export function ContextMenuItem({
  iconName,
  text,
  onSelect,
  disabled,
  tooltipContent,
}: ContextMenuItemProps): React.JSX.Element {
  return (
    <Tooltip displayAsChild={true} xPosition="center" enabled={disabled}>
      <StyledContextMenuItem onSelect={onSelect} disabled={disabled}>
        <tractie-icon name={iconName} /> {text}
      </StyledContextMenuItem>
      <TooltipContentContainer>{tooltipContent}</TooltipContentContainer>
    </Tooltip>
  );
}
